import React, { Component } from 'react';
import {browserHistory} from "react-router";
//import './bootstrap.min.css';
import '../CSS/login.css';

import SimpleStorageContract from "../contracts/SimpleStorage.json";
import getWeb3 from "../utils/getWeb3";

class Registrion extends Component {
    constructor(props) {
        super(props);
        this.state ={
            fname:'',
            lname:'',
            email:'',
            password:'',
            meta_key:'',
            bio:'',
			company:'',
			companys:[]
        };
        this.register = this.register.bind(this);
    }

    register(){
      
        fetch(`
      http://52.60.64.107/api/orginatorx-new/sign-up.php?f_name=${this.state.fname}&l_name=${this.state.lname}&
	  meta_key=${this.state.meta_key}&email=${this.state.email}&password=${this.state.password}&company=${this.state.company}`)
                    .then(response => response.json())
                    .then(data => {
                      this.setState({bio: ''});
                        this.setState({fname: ''});
                        this.setState({l_name: ''});
                        this.setState({meta_key: ''});
                        this.setState({email: ''});
                        this.setState({password: ''});
                        this.setState({company: ''});
						browserHistory.push("/home");
                    });
    }
	componentDidMount = async () => {
		
        fetch(`http://52.60.64.107/api/orginatorx-new/get-all-compunys.php`)
                    .then(response => response.json())
                    .then(data => {
						console.log(data)
						this.setState({companys: data.result })
						console.log(this.state.companys)
					})

					 try {
          // Get network provider and web3 instance.
          const web3 = await getWeb3();
          // Use web3 to get the user's accounts.
          const accounts = await web3.eth.getAccounts();
			this.setState({meta_key: accounts[0]})
          console.log(accounts)
        } catch (error) {
          // Catch any errors for any of the above operations.
          alert(
            `Failed to load web3, accounts, or contract. Check console for details.`,
          );
          console.error(error);
        }
	}

    render() {

        return (
            <div> 
                <div className="overflow-hidden">
                <div class="edit_profile register">
				<div class="container">
					<div class="row">
						<div class="col s9"></div>
						<div class="col s9 offset-s3">
							<div class="right_part space-y-20">
								<h1 class="color_white"> Create new account</h1>
								<p class="color_white" 
									>You can set preferred display name, create your profile URL and
									manage other personal settings.</p
								>
								<div class="box edit_box w-full space-y-20">
									<div class="row">
										<div class="col s6 account-info">
											
											<h3 class="mb-20 color_white"> 🍉 Account info </h3>
											<div class="form-group space-y-10 mb-0">
												<div class="space-y-20">
													<div class="space-y-10">
														<span class="nameInput">First name</span>
														<input
															type="text"
															class="form-control"
															placeholder="Enter your first name"
                                                            value={this.state.fname}
                                                            onChange={(e)=>this.setState({fname:e.target.value }) }
														/>
													</div>
													<div class="space-y-10">
														<span class="nameInput">Email</span>
														<input
															type="text"
															class="form-control"
															placeholder="name@gmail.com"
                                                            value={this.state.email}
                                                            onChange={(e)=>this.setState({email: e.target.value})}
														/>
													</div>
												</div>
											</div>
										</div>
										<div class="col s6 account-info">
											
											<h3 class="mb-20"> &nbsp; </h3>
											<div class="form-group space-y-10 mb-0">
												<div class="space-y-20">
													<div class="space-y-10">
														<span class="nameInput">Last name</span>
														<input
															type="text"
															class="form-control"
															placeholder="Enter your last name"
                                                            value={this.state.lname}
                                                            onChange={(e)=>this.setState({lname: e.target.value }) }
														/>
													</div>
													<div class="space-y-10">
														<span class="nameInput">Password</span>
														<input
															type="password"
															class="form-control"
															placeholder="********"
                                                            value={this.state.password}
                                                            onChange={(e)=>this.setState({password: e.target.value})}
														/>
													</div>
													
												</div>
											</div>
										</div>
										<div class="col-lg-12 account-info">
										<div class="space-y-10">
											<span class="nameInput">Wallet address</span>
											<input
												type="text"
												class="form-control"
												placeholder="0000-dsdjkk-88787888"
												value={this.state.meta_key}
												onChange={(e)=>this.setState({meta_key: e.target.value})}
											/>
										</div>

										<div class="space-y-10">
											<span class="nameInput">Registered company</span>
											<select className='form-control' name='registered company' 
											value={this.state.company}
											onChange={(e)=>this.setState({company: e.target.value})}>
												<option value="">Select</option>
												{this.state.companys && this.state.companys.length >0 &&
												<>
												{this.state.companys.map((e, key) => {
													return <option key={key} value={e.id}>{e.company_name}</option>;
												})}
												</>
												}
											</select>
										</div>

										<div class="space-y-10">
											<span class="nameInput">Bio</span>
											<textarea class="form-control" placeholder='Bio'
											rows={3}
											style={{minHeight:'150px'}}
											value={this.state.bio}
											onChange={(e)=>this.setState({bio: e.target.value})}></textarea>
										</div>
										</div>
									</div>
									<div class="hr"></div>
									<p class="" style={{color:'white'}}
										>Please take a few minutes to read and understand Stacks Terms of
										Service. To continue, you’ll need to accept the terms of services
										by checking the boxes.</p
									>
									<button type='button' class="btn btn-grad" onClick={this.register} >Create</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

                </div>
            </div>
        );
    }
}

export default Registrion;